<app-header></app-header>
<div class="content small-head">
  <mat-card appearance="outlined" class="info-card">
    <div>
      @if (bookType !== 'KBW') {
        <div class="select-training-text">
          <h3>{{'KbTitle' | translate }}</h3>
        </div>
      } @else {
        <h3>{{'KbwTitle' | translate }}</h3>
      }
    </div>
    <ng-template #kfrLogo>
      <div class="kfr-logo">
        <!-- <img class="logo" src="../../../assets/logo-circle.png" alt="Swiss Krono"> -->
      </div>
    </ng-template>
    <mat-button-toggle-group name="fontStyle" aria-label="Font Style" class="lang-btns" value="{{selectedLang}}">

      @for (lng of langs; track lng) {
        <mat-button-toggle mat-icon-button color="primary" aria-label="{{lng.desc}}" value="{{lng.name}}" (click)="setLang(lng.code)">
          <div class="flag-wrapper">
            <div class="flag flag-icon-background flag-icon-{{lng.name}}"></div>
          </div>
          <span>{{lng.desc}}</span>
        </mat-button-toggle>
      }
    </mat-button-toggle-group>
    <mat-divider></mat-divider>
    <div class="select-training-text">
      <h3>{{'SelectTraining' | translate }}</h3>
    </div>
    @if (isLoadnig) {
      <mat-progress-spinner
        class="spinner-margin"
        color="accent"
        [mode]="mode"
        diameter="100"
        [value]="value">
      </mat-progress-spinner>
    }
    @if (!isLoadnig) {
      <mat-button-toggle-group name="fontStyle" aria-label="Font Style" class="train-btns" value="{{selectedExam}}">
        @for (train of trainings; track train; let indx = $index) {
          <mat-button-toggle mat-icon-button aria-label="" value="{{train.trainingTypeId}}" (change)="selectionChanged($event.value)">
            <span>{{train.description}}</span>
          </mat-button-toggle>
        }
      </mat-button-toggle-group>
    }
    <mat-divider></mat-divider>
    <button mat-raised-button color="primary" class="next-btn" [disabled]="isLoadnig" (click)=onClick()>{{'NextBtn' | translate}}</button>
    @if (backBtnVisible) {
      <span>
        <a mat-raised-button color="accent" style="margin-top: 10px; display: grid;" href="/bookselect">
          {{'BackBtn' | translate}}
        </a>
      </span>
    }
  </mat-card>
</div>

